
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/stores",
      function () {
        return require("private-next-pages/profile/stores.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/stores"])
      });
    }
  